export default __webpack_public_path__ + "static/banner2-ab982c42095da43f87f1183982a57275.jpg";